export default "__VITE_ASSET__Cqlhe9lt__"